module.exports = __webpack_public_path__ + "img/star_empty.3b3c62c4.svg";